(() => {
  'use strict';

  const categoryMap = {
    katten: ['katten'], honden: ['honden'], literatuur: ['proza', 'kort-en-goed'], poezie: ['poezie'],
    kunst: ['kunst'], muziek: ['muziek'], voetbal: ['voetbal'], sport: ['sport'], wielrennen: ['sport'],
    amsterdam: ['bouwkunst'], rotterdam: [], architectuur: ['bouwkunst'],
    koken: ['koken'], reizen: ['proza', 'biografieen'], humor: ['lachen', 'light-verse', 'strips'], taal: ['light-verse', 'poezie'],
    geschiedenis: ['oud-goud', 'biografieen', 'oorlog'], oorlog: ['oorlog'], nederland: ['proza', 'oud-goud'],
    journalistiek: ['journalistiek'], ruimtevaart: ['science-fiction'], beatles: ['muziek'],
    'rolling-stones': ['muziek'], rock: ['muziek'], koningshuis: ['oranjehuis'], 'maakt-niet-uit': [],
  };
  const childNumbers = new Set([12, 13, 23, 26, 27, 28, 31, 36, 66, 67]);
  const exactInterestNumbers = {
    amsterdam: new Set([115, 30, 174, 175, 176, 177, 178, 184, 185, 186, 187]),
    rotterdam: new Set([40]),
    wielrennen: new Set([5]),
  };
  /*
   * V87: vaste productnummerselecties op basis van de aangeleverde
   * productteksten. De gekozen gelegenheid wordt hiermee daadwerkelijk in de
   * filtering gebruikt; tijdens het winkelen worden geen losse zoekwoorden op
   * productteksten toegepast.
   */
  const occasionGroups = [
    [/verlies.*huisdier/, new Set([38, 68])],
    [/condoleance|troost/, new Set([7, 41, 51, 68, 152])],
    [/herdenken|herinneren/, new Set([41, 43, 51, 52, 53, 54, 58, 73, 75, 98, 104, 105, 106, 107, 108, 113, 121, 143, 144, 145, 146, 147, 148, 149, 152, 162])],
    [/sterkte|aanmoediging/, new Set([7, 9, 27, 35, 41, 45, 46, 47, 48, 51, 57, 58, 68, 73, 75, 89, 98, 102, 104, 105, 106, 107, 108, 109, 114, 116, 117, 118, 136, 148, 149, 152, 153, 162])],
    [/afscheid/, new Set([7, 10, 35, 38, 41, 48, 51, 53, 58, 68, 73, 75, 89, 98, 115, 148, 152])],
    [/pensioen/, new Set([14, 34, 41, 44, 55, 64, 76, 77, 78, 79, 80, 82, 85, 86, 90, 99, 100, 101, 102, 103, 114, 116, 117, 118, 124, 125, 126, 127, 128, 129, 132, 135, 137, 151, 153, 160, 161, 188])],
    [/nieuwe baan|promotie/, new Set([8, 14, 34, 35, 41, 46, 56, 70, 71, 99, 101, 102, 109, 114, 116, 117])],
    [/afstuderen|diploma/, new Set([8, 13, 14, 23, 26, 27, 35, 37, 41, 46, 59, 70, 71, 99, 101, 102, 109, 114, 116, 117])],
    [/geboorte|jonge ouders/, new Set([8, 12, 23, 26, 27, 28, 33, 45, 66, 67, 91, 92, 93, 94, 95, 159, 162])],
    [/nieuw huis|housewarming/, new Set([2, 10, 14, 30, 33, 40, 41, 44, 52, 56, 59, 69, 78, 161, 173, 183])],
    [/moederdag|familie/, new Set([8, 12, 26, 33, 45, 48, 51, 52, 57, 58, 66, 67, 91, 92, 93, 94, 95, 150, 162])],
    [/vaderdag/, new Set([5, 16, 19, 33, 34, 37, 43, 44, 58, 61, 62, 63, 64, 73, 76, 77, 78, 79, 80, 88, 96, 97, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 114, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 132, 143, 144, 145, 146, 147, 148, 149, 154, 155, 156, 157, 158, 163, 164, 165, 166, 167, 188])],
    [/liefde|romantiek/, new Set([3, 18, 19, 24, 29, 35, 45, 48, 50, 136, 150])],
    [/huwelijk/, new Set([3, 19, 24, 50, 136, 150])],
    [/jubileum/, new Set([14, 22, 32, 34, 41, 49, 64, 80, 85, 90, 95, 97, 103, 118, 123, 129, 135, 137, 147, 150, 151, 153, 158, 159, 160, 161, 167, 168, 188])],
    [/vriendschap/, new Set([19, 33, 34, 36, 41, 45, 67, 114, 116, 117, 118, 150])],
    [/bedankt|waardering/, new Set([14, 33, 34, 41, 44, 50, 52, 79, 82, 99, 101, 114, 116, 117, 118, 136, 150])],
    [/kerst|sinterklaas|feestdagen/, new Set([2, 12, 14, 22, 24, 28, 32, 34, 37, 44, 49, 64, 65, 67, 69, 74, 80, 85, 90, 95, 97, 103, 118, 123, 129, 131, 132, 133, 134, 135, 137, 147, 150, 151, 153, 158, 159, 160, 161, 162, 167, 168, 173, 183, 188])],
    [/relatiegeschenk/, new Set([22, 28, 32, 42, 49, 54, 60, 64, 65, 67, 69, 74, 80, 85, 90, 95, 97, 103, 108, 118, 123, 129, 131, 132, 133, 134, 135, 137, 147, 149, 150, 151, 153, 158, 159, 160, 161, 162, 167, 168, 173, 183, 188])],
    [/verjaardag/, new Set([2, 5, 8, 12, 13, 14, 19, 20, 22, 23, 24, 25, 26, 27, 28, 30, 31, 32, 33, 34, 36, 37, 40, 41, 44, 45, 46, 47, 48, 49, 50, 55, 56, 59, 60, 64, 65, 66, 67, 69, 70, 71, 72, 74, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 90, 91, 92, 93, 94, 95, 96, 97, 99, 100, 101, 102, 103, 109, 114, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 143, 144, 145, 146, 147, 150, 151, 153, 154, 155, 156, 157, 158, 159, 160, 161, 163, 164, 165, 166, 167, 168, 173, 183, 188])],
  ];
  const interestGroups = [
    ['Plaatsen', ['amsterdam', 'rotterdam']],
    ['Muziek', ['muziek', 'beatles', 'rolling-stones', 'rock']],
    ['Sport', ['sport', 'voetbal', 'wielrennen']],
    ['Thema’s & cultuur', ['katten', 'honden', 'literatuur', 'poezie', 'kunst', 'architectuur', 'koken', 'reizen', 'humor', 'taal', 'geschiedenis', 'oorlog', 'nederland', 'journalistiek', 'ruimtevaart', 'koningshuis', 'maakt-niet-uit']],
  ];
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const displayTitle = (title, creators = []) => {
    let result = String(title || '').trim();
    creators.filter(Boolean).forEach((creator) => {
      result = result.replace(new RegExp(`^${escapeRegExp(creator)}\\s*[–—-]\\s*`, 'i'), '').trim();
    });
    return result;
  };

  const scrollBelowHeader = (target) => {
    if (!target) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const header = document.querySelector('.section-matchboox-header, .section-header');
        const headerHeight = header?.getBoundingClientRect().height || 0;
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 18;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
  };

  const parseData = () => {
    const source = document.querySelector('script[id^="MatchBooxCarouselData-"]');
    if (!source) return null;
    try { return JSON.parse(source.textContent); }
    catch (error) {
      console.error('De gegevens voor de cadeaukiezer konden niet worden gelezen.', error);
      return null;
    }
  };

  const parseShopifyPrimaryImageMap = () => {
    const source = document.querySelector('[data-mb-gift-primary-image-map]');
    if (!source) return {};
    try { return JSON.parse(source.textContent); }
    catch (error) {
      console.error('De Shopify-afbeeldingen voor de cadeaukiezer konden niet worden gelezen.', error);
      return {};
    }
  };

  const unique = (items) => {
    const seen = new Set();
    return items.filter((item) => item && !seen.has(item.number) && seen.add(item.number));
  };

  const isGiftCard = (item) => item?.handle === 'matchboox-cadeaubon' || normalize(item?.title).includes('cadeaubon');
  const giftCardLast = (items) => [...items.filter((item) => !isGiftCard(item)), ...items.filter(isGiftCard)];

  const init = () => {
    const originalRoot = document.querySelector('.mb-page-content[data-page-handle="vind-het-juiste-cadeau"] #mb-funnel');
    const data = parseData();
    const shopifyPrimaryImageByHandle = parseShopifyPrimaryImageMap();
    if (!originalRoot || !data || originalRoot.dataset.mbGiftReady === 'true') return;

    /*
     * De Shopify-pagina bevat nog de oorspronkelijke cadeaukiezer-code. Een
     * diepe kloon verwijdert de oude klikhandlers voordat de nieuwe kiezer
     * wordt opgebouwd, zodat beide versies nooit tegelijk resultaten tekenen.
     */
    const root = originalRoot.cloneNode(true);
    originalRoot.replaceWith(root);

    const steps = { 1: root.querySelector('#step1'), 2: root.querySelector('#step2'), 3: root.querySelector('#step3') };
    const results = root.querySelector('#results');
    const grid = root.querySelector('#resultGrid');
    const intro = root.querySelector('#resultIntro');
    const choices = { 1: null, 2: [], 3: null };
    let productObserver = null;
    if (!steps[1] || !steps[2] || !steps[3] || !results || !grid) return;

    /* De geïmporteerde pagina heeft eigen #results- en #resultGrid-regels.
       Gebruik aparte IDs voor de opnieuw opgebouwde resultaten, zodat die
       oude rasterregels geen kaart tot een smalle kolom kunnen drukken. */
    results.id = 'mbGiftResults';
    grid.id = 'mbGiftResultsTrack';

    /* Verwijder eerst de oude paginaknoppen. Die stonden ook op de eerste
       stap, terwijl daar nog geen vorige selectie bestaat. */
    root.querySelectorAll('#again, #top').forEach((button) => button.remove());

    /* Bouw de resultaatkop en navigatie opnieuw op. Daarmee blijven de
       gewenste onderdelen behouden zonder de oude hoogtehouders en dubbele
       scripts uit de Shopify-pagina terug te brengen. */
    const resultTitle = document.createElement('h2');
    resultTitle.className = 'mb-gift-results__title';
    resultTitle.textContent = 'Dit zijn uw MatchBoox-cadeauadviezen';

    const resultActions = document.createElement('div');
    resultActions.className = 'mb-gift-results__actions';
    const resultPrevious = document.createElement('button');
    resultPrevious.type = 'button';
    resultPrevious.id = 'again';
    resultPrevious.className = 'mb-gift-results__back';
    resultPrevious.textContent = 'Terug naar vorige selectie';
    const resultRestart = document.createElement('button');
    resultRestart.type = 'button';
    resultRestart.id = 'top';
    resultRestart.className = 'mb-gift-results__back mbf-restart';
    resultRestart.textContent = 'Terug naar de cadeaukiezer';
    resultActions.append(resultPrevious, resultRestart);

    results.replaceChildren(resultTitle, grid, resultActions);
    results.removeAttribute('style');
    results.className = 'mb-discovery mb-gift-results-view';
    results.hidden = true;
    grid.removeAttribute('style');
    grid.removeAttribute('hidden');
    let fondsAuthors = {};
    const fondsSource = document.querySelector('[data-mb-fonds-authors]');
    if (fondsSource) {
      try { fondsAuthors = JSON.parse(fondsSource.textContent); } catch (_error) { fondsAuthors = {}; }
    }
    const fondsAdditions = document.querySelector('[data-mb-fonds-author-additions]');
    if (fondsAdditions) {
      try {
        Object.entries(JSON.parse(fondsAdditions.textContent)).forEach(([name, handles]) => {
          fondsAuthors[name] = [...new Set([...(fondsAuthors[name] || []), ...handles])];
        });
      } catch (_error) { /* Behoud de fondslijst. */ }
    }
    const authorsFor = (item) => Object.entries(fondsAuthors)
      .filter(([, handles]) => Array.isArray(handles) && handles.includes(item.handle))
      .map(([name]) => name)
      .join(', ');
    const visualSignature = (item) => (Math.max(1, Math.ceil(String(item.title || '').length / 29)) * 100) + Math.max(1, Math.ceil(authorsFor(item).length / 34));
    const sortVisual = (items) => [...items].sort((a, b) => visualSignature(a) - visualSignature(b) || String(a.title).localeCompare(String(b.title), 'nl'));
    const allCatalog = unique([...(data.large || []), ...(data.categories || []).flatMap((group) => group.items || [])]);
    const giftCardItem = allCatalog.find(isGiftCard) || {
      number: 'matchboox-cadeaubon',
      handle: 'matchboox-cadeaubon',
      title: 'MatchBoox-cadeaubon',
      caption: '',
      url: '/products/matchboox-cadeaubon',
    };
    const catalogByHandle = new Map(allCatalog.map((item) => [item.handle, item]));
    const shopifyProductCache = new Map();
    const loadShopifyProduct = (item) => {
      if (!shopifyProductCache.has(item.handle)) {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const productUrl = `${shopRoot.replace(/\/?$/, '/')}products/${item.handle}.js`;
        shopifyProductCache.set(item.handle, fetch(productUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }).then((response) => {
          if (!response.ok) throw new Error('Shopify-productgegevens niet beschikbaar');
          return response.json();
        }));
      }
      return shopifyProductCache.get(item.handle);
    };
    const arrangeSeries = (items) => {
      const groups = window.MatchBooxSeriesGroups || {};
      const used = new Set();
      const output = [];
      const seriesHandles = [];
      const memberToSeries = new Map();
      Object.entries(groups).forEach(([seriesHandle, handles]) => handles.forEach((handle) => memberToSeries.set(handle, seriesHandle)));
      items.forEach((item) => {
        const seriesHandle = groups[item.handle] ? item.handle : Object.keys(groups).find((handle) => groups[handle].includes(item.handle));
        if (seriesHandle && !seriesHandles.includes(seriesHandle)) seriesHandles.push(seriesHandle);
      });
      const authorSeen = new Set();
      const diverseLoose = [];
      const repeatedLoose = [];
      items.filter((item) => !groups[item.handle] && !memberToSeries.has(item.handle)).forEach((item) => {
        const author = authorsFor(item).toLowerCase();
        if (author && !authorSeen.has(author)) {
          authorSeen.add(author);
          diverseLoose.push(item);
        } else {
          repeatedLoose.push(item);
        }
      });
      [...sortVisual(diverseLoose), ...sortVisual(repeatedLoose)]
        .forEach((item) => { output.push(item); used.add(item.handle); });
      seriesHandles.forEach((seriesHandle) => [seriesHandle, ...(groups[seriesHandle] || [])].forEach((handle) => {
        const product = catalogByHandle.get(handle);
        if (product && !used.has(handle)) { output.push(product); used.add(handle); }
      }));
      sortVisual(items.filter((item) => !used.has(item.handle)))
        .forEach((item) => { output.push(item); used.add(item.handle); });
      return output;
    };

    const setStepIntroduction = (sectionNumber, progressNumber, title, help) => {
      const section = steps[sectionNumber];
      const heading = section.querySelector('h1, h2, h3');
      if (!heading) return;
      heading.textContent = title;
      section.querySelectorAll('p').forEach((paragraph) => {
        if (!paragraph.closest('.mbf-choice')) paragraph.remove();
      });
      const progress = document.createElement('p');
      progress.className = 'mbf-progress';
      progress.textContent = `Stap ${progressNumber} van 3`;
      heading.before(progress);
      if (help) {
        const explanation = document.createElement('p');
        explanation.className = 'mbf-step-help';
        explanation.textContent = help;
        heading.after(explanation);
      }
      section.classList.add(`mbf-step--flow-${progressNumber}`);
    };
    setStepIntroduction(3, 1, 'Voor wie is het cadeau?', '');
    setStepIntroduction(1, 2, 'Voor welke gelegenheid kiest u een cadeau?', 'Kies het moment dat het beste past.');
    setStepIntroduction(2, 3, 'Waar houdt de ontvanger van?', 'Kies één of meer interesses.');
    [...root.querySelectorAll('p, h1, h2, h3, h4')].forEach((node) => {
      if (normalize(node.textContent).includes('selecteer in 3 stappen')) node.remove();
    });
    const groupChoices = (step, definitions, layoutModifier) => {
      const buttons = [...steps[step].querySelectorAll(`.mbf-choice[data-step="${step}"]`)]
        .filter((button) => button.dataset.value !== 'erotisch');
      const parent = buttons[0]?.parentElement;
      if (!parent || buttons.some((button) => button.parentElement !== parent)) return;
      parent.classList.add('mbf-native-grid-reset');
      const layout = document.createElement('div');
      layout.className = `mbf-groups-layout mbf-groups-layout--${layoutModifier}`;
      parent.insertBefore(layout, buttons[0]);
      const grouped = new Set();
      definitions.forEach(([title, values, modifier = '']) => {
        const matches = values.map((value) => buttons.find((button) => button.dataset.value === value)).filter(Boolean);
        if (!matches.length) return;
        const group = document.createElement('section');
        group.className = `mbf-choice-group${modifier ? ` mbf-choice-group--${modifier}` : ''}`;
        const list = document.createElement('div');
        list.className = 'mbf-choice-group__grid';
        matches.forEach((button) => { grouped.add(button); list.append(button); });
        if (title) {
          const heading = document.createElement('h3');
          heading.textContent = title;
          group.append(heading);
        }
        group.append(list);
        layout.append(group);
      });
      const remaining = buttons.filter((button) => !grouped.has(button));
      if (remaining.length) {
        const group = document.createElement('section');
        group.className = 'mbf-choice-group';
        const list = document.createElement('div');
        list.className = 'mbf-choice-group__grid';
        remaining.forEach((button) => list.append(button));
        group.append(list);
        layout.append(group);
      }
    };

    [...steps[2].querySelectorAll('.mbf-choice[data-step="2"]')]
      .filter((button) => /bergen/.test(normalize(`${button.dataset.value} ${button.textContent}`)))
      .forEach((button) => button.remove());

    const recipientButtons = [...steps[3].querySelectorAll('.mbf-choice[data-step="3"]')];
    const adultButton = recipientButtons.find((button) => button.dataset.value !== 'kind' && button.dataset.value !== 'erotisch');
    const childButton = recipientButtons.find((button) => button.dataset.value === 'kind');
    groupChoices(3, [['', [adultButton?.dataset.value, childButton?.dataset.value].filter(Boolean)]], 'recipient');

    const stepOneButtons = [...steps[1].querySelectorAll('.mbf-choice[data-step="1"]')];
    const difficultValues = stepOneButtons
      .filter((button) => /afscheid|verlies|condoleance|troost|sterkte|rouw/.test(normalize(button.textContent)))
      .map((button) => button.dataset.value);
    const celebratoryValues = stepOneButtons
      .filter((button) => !difficultValues.includes(button.dataset.value))
      .map((button) => button.dataset.value);
    groupChoices(1, [
      ['Feestelijke en persoonlijke momenten', celebratoryValues],
      ['Afscheid, troost en moeilijke momenten', difficultValues, 'quiet'],
    ], 'occasion');
    groupChoices(2, interestGroups, 'interests');

    let adviceButton = steps[2].querySelector('.mbf-primary-action');
    if (!adviceButton) {
      adviceButton = document.createElement('button');
      steps[2].append(adviceButton);
    }
    adviceButton.type = 'button';
    adviceButton.className = 'mbf-primary-action';
    adviceButton.textContent = 'Geef mijn cadeauadvies';
    adviceButton.disabled = true;
    steps[2].append(adviceButton);

    const matchCounter = document.createElement('p');
    matchCounter.className = 'mbf-match-count';
    matchCounter.setAttribute('aria-live', 'polite');

    steps[3].querySelector('.mbf-choice[data-value="erotisch"]')?.remove();

    const showStep = (number, shouldScroll = true) => {
      Object.entries(steps).forEach(([key, section]) => { section.hidden = Number(key) !== number; });
      results.hidden = true;
      const help = steps[number]?.querySelector('.mbf-step-help');
      if (help) help.after(matchCounter);
      else steps[number]?.querySelector('h1, h2, h3')?.after(matchCounter);
      if (shouldScroll) scrollBelowHeader(steps[number]);
    };

    /* V2: interesse is leidend, gelegenheid bepaalt de volgorde. Alleen bij
       verdrietige gelegenheden blijft de gelegenheid een harde filter, zodat
       daar nooit luchtige titels verschijnen. Titels die bij meerdere gekozen
       interesses passen staan bovenaan. */
    const sensitiveOccasion = (value) => /verlies|condoleance|troost|afscheid|sterkte|rouw|herdenken|herinneren/.test(value);
    const interestItemsFor = (interest) => {
      const exactNumbers = exactInterestNumbers[interest];
      if (exactNumbers) return allCatalog.filter((item) => exactNumbers.has(item.number));
      return (categoryMap[interest] || []).flatMap((handle) => data.categories.find((group) => group.handle === handle)?.items || []);
    };
    const selectItems = (limit = 0) => {
      const interests = (Array.isArray(choices[2]) ? choices[2] : (choices[2] ? [choices[2]] : [])).filter(Boolean);
      const occasionChoice = normalize(choices[1]);
      const occasionNumbers = occasionGroups.find(([pattern]) => pattern.test(occasionChoice))?.[1] || null;
      const sensitive = sensitiveOccasion(occasionChoice);
      const specific = interests.filter((interest) => interest !== 'maakt-niet-uit');
      const hits = new Map();
      specific.forEach((interest) => {
        new Set(interestItemsFor(interest).map((item) => item.number)).forEach((number) => hits.set(number, (hits.get(number) || 0) + 1));
      });
      let pool = allCatalog.filter((item) => !isGiftCard(item));
      if (choices[3] === 'kind') pool = pool.filter((item) => childNumbers.has(item.number));
      else pool = pool.filter((item) => !childNumbers.has(item.number));
      const inOccasion = (item) => !occasionNumbers || occasionNumbers.has(item.number);
      let items;
      if (specific.length) {
        items = pool.filter((item) => hits.has(item.number));
        if (sensitive && occasionNumbers) {
          const strict = items.filter(inOccasion);
          items = strict.length ? strict : pool.filter(inOccasion);
        }
        if (!items.length && choices[3] === 'kind') items = pool.filter(inOccasion);
      } else {
        items = occasionNumbers ? pool.filter(inOccasion) : pool;
        if (!items.length) items = pool;
      }
      const position = new Map(pool.map((item, index) => [item.number, index]));
      const byFit = (x, y) => Number(inOccasion(y)) - Number(inOccasion(x)) || position.get(x.number) - position.get(y.number);
      items = unique(items);
      if (specific.length > 1) {
        /* Eerst titels die bij meerdere interesses passen, daarna om en om uit
           iedere gekozen interesse, zodat een kleine interesse (bijv. honden)
           niet onderaan verdwijnt. */
        const chosen = new Set(items.map((item) => item.number));
        const multi = items.filter((item) => (hits.get(item.number) || 0) > 1).sort(byFit);
        const used = new Set(multi.map((item) => item.number));
        const lists = specific.map((interest) => unique(interestItemsFor(interest))
          .filter((item) => chosen.has(item.number) && !used.has(item.number))
          .map((item) => items.find((x) => x.number === item.number))
          .sort(byFit));
        const mixed = [...multi];
        for (let round = 0; lists.some((list) => list.length); round += 1) {
          lists.forEach((list) => {
            while (list.length && used.has(list[0].number)) list.shift();
            const next = list.shift();
            if (next) { mixed.push(next); used.add(next.number); }
          });
        }
        items = [...mixed, ...items.filter((item) => !used.has(item.number)).sort(byFit)];
      } else {
        items = items.sort(byFit);
      }
      const orderedItems = [...items, giftCardItem];
      return limit > 0 ? orderedItems.slice(0, limit) : orderedItems;
    };

    const updateMatchCounter = () => {
      const count = selectItems(0).length;
      matchCounter.textContent = `${count} passende ${count === 1 ? 'uitgave' : 'uitgaven'}`;
    };

    const enrichCard = async (card, item) => {
      try {
        const product = await loadShopifyProduct(item);
        const isIllustratorVersion = (product.variants || []).some((variant) => /\s[BDEFHKL]$/i.test(String(variant?.sku || '').trim())) || [].concat(product.tags || []).some((tag) => /^(Illustrator|Vormgever|Alternatieve)-editie$/.test(String(tag).trim()));
        if (isIllustratorVersion) {
          card.remove();
          return;
        }
        const image = card.querySelector('.mb-discovery__cover img');
        const themeImage = item.image || '';
        const shopifyPrimaryImage = shopifyPrimaryImageByHandle[item.handle] || product.images?.[0]?.src || product.images?.[0] || '';
        const preferredImage = shopifyPrimaryImage || (item.handle === 'remco-campert-de-bloem' ? '' : themeImage);
        if (image && preferredImage) {
          image.onerror = item.handle !== 'remco-campert-de-bloem' && themeImage && preferredImage !== themeImage
            ? () => {
                image.onerror = null;
                image.src = themeImage;
              }
            : null;
          image.addEventListener('load', () => {
            image.closest('.mb-discovery__cover')?.classList.add('is-loaded');
          }, { once: true });
          image.src = preferredImage;
          if (image.complete && image.naturalWidth > 0) image.closest('.mb-discovery__cover')?.classList.add('is-loaded');
        }
        const title = card.querySelector('strong');
        if (title && product.title) {
          title.textContent = displayTitle(product.title, [authorsFor(item), item.caption]);
          title.hidden = false;
        }
      } catch (_error) { /* De vaste gegevens uit het keuzeblok blijven zichtbaar. */ }
    };

    const renderResults = (shouldScroll = false) => {
      const items = selectItems();
      const fragment = document.createDocumentFragment();
      const cardsToEnrich = [];
      items.forEach((item, index) => {
        const card = document.createElement('a');
        card.className = 'mb-discovery__card';
        card.href = item.url;
        card.dataset.productHandle = item.handle;
        const cover = document.createElement('div');
        cover.className = 'mb-discovery__cover';
        const image = document.createElement('img');
        image.loading = index < 5 ? 'eager' : 'lazy';
        image.decoding = 'async';
        image.alt = `Productafbeelding 1 van ${item.title}`;
        const themeImage = item.image || '';
        const shopifyPrimaryImage = shopifyPrimaryImageByHandle[item.handle] || '';
        const initialImage = shopifyPrimaryImage || (item.handle === 'remco-campert-de-bloem' ? '' : themeImage);
        if (initialImage) {
          image.onerror = item.handle !== 'remco-campert-de-bloem' && themeImage && initialImage !== themeImage
            ? () => {
                image.onerror = null;
                image.src = themeImage;
              }
            : null;
          image.addEventListener('load', () => cover.classList.add('is-loaded'), { once: true });
          image.src = initialImage;
          if (image.complete && image.naturalWidth > 0) cover.classList.add('is-loaded');
        }
        const coverContent = document.createElement('span');
        coverContent.className = 'mb-gift-cover-content';
        coverContent.setAttribute('aria-hidden', 'true');
        cover.append(image, coverContent);
        const title = document.createElement('strong');
        const authors = authorsFor(item) || (normalize(item.caption) !== normalize(item.title) ? item.caption : '');
        title.textContent = displayTitle(item.title, [authors, item.caption]);
        title.hidden = false;
        card.append(cover, title);
        if (authors) {
          const author = document.createElement('span');
          author.textContent = authors;
          card.append(author);
        }
        fragment.append(card);
        cardsToEnrich.push({ card, item, index });
      });
      grid.replaceChildren(fragment);
      grid.className = 'mb-discovery__track';
      grid.removeAttribute('style');
      if (items.length < 5) grid.classList.add('is-short');
      productObserver?.disconnect();
      productObserver = null;
      cardsToEnrich.slice(0, 5).forEach(({ card, item }) => enrichCard(card, item));
      const deferredCards = cardsToEnrich.slice(5);
      if ('IntersectionObserver' in window && deferredCards.length) {
        const cardItems = new WeakMap(deferredCards.map(({ card, item }) => [card, item]));
        productObserver = new IntersectionObserver((entries) => {
          entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
            productObserver.unobserve(entry.target);
            enrichCard(entry.target, cardItems.get(entry.target));
          });
        }, { root: grid, rootMargin: '0px 100%', threshold: 0.01 });
        deferredCards.forEach(({ card }) => productObserver.observe(card));
      } else {
        deferredCards.forEach(({ card, item }) => enrichCard(card, item));
      }
      let stage = grid.closest('.mb-gift-results-stage');
      if (!stage) {
        stage = document.createElement('div');
        stage.className = 'mb-discovery__carousel mb-gift-results-stage';
        const previous = document.createElement('button');
        previous.type = 'button';
        previous.className = 'mb-discovery__arrow mb-discovery__arrow--prev';
        previous.setAttribute('aria-label', 'Vorige resultaten');
        previous.textContent = '<';
        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'mb-discovery__arrow mb-discovery__arrow--next';
        next.setAttribute('aria-label', 'Volgende resultaten');
        next.textContent = '>';
        grid.before(stage);
        stage.append(previous, grid, next);
        previous.addEventListener('click', () => grid.scrollBy({ left: -grid.clientWidth, behavior: 'smooth' }));
        next.addEventListener('click', () => grid.scrollBy({ left: grid.clientWidth, behavior: 'smooth' }));
      }
      stage.classList.toggle('is-short', items.length < 5);
      const previous = stage.querySelector('.mb-discovery__arrow--prev');
      const next = stage.querySelector('.mb-discovery__arrow--next');
      previous.hidden = items.length <= 1;
      next.hidden = items.length <= 1;
      const updateArrows = () => {
        const end = grid.scrollWidth - grid.clientWidth;
        previous.disabled = grid.scrollLeft <= 2;
        next.disabled = grid.scrollLeft >= end - 2;
      };
      if (grid.dataset.mbGiftScrollReady !== 'true') {
        grid.addEventListener('scroll', updateArrows, { passive: true });
        grid.dataset.mbGiftScrollReady = 'true';
      }
      requestAnimationFrame(updateArrows);
      let count = results.querySelector('.mb-gift-results__count');
      if (!count) {
        count = document.createElement('p');
        count.className = 'mb-gift-results__count';
        resultTitle.after(count);
      }
      count.textContent = `${items.length} ${items.length === 1 ? 'uitgave' : 'uitgaven'}`;
      resultPrevious.hidden = !choices[3];
      results.hidden = false;
      if (shouldScroll) scrollBelowHeader(results);
    };

    const refreshSelection = () => {
      updateMatchCounter();
      results.hidden = true;
    };

    const clearStep = (number) => {
      choices[number] = number === 2 ? [] : null;
      steps[number].querySelectorAll('.mbf-choice').forEach((button) => button.classList.remove('is-active'));
    };
    const startOver = (shouldScroll = true) => {
      clearStep(1); clearStep(2); clearStep(3);
      adviceButton.disabled = true;
      showStep(3, false);
      refreshSelection();
      if (shouldScroll) scrollBelowHeader(root.closest('.mb-page-content') || root);
    };
    const previousSelection = () => {
      showStep(2);
    };
    const goToOccasion = () => {
      clearStep(1); clearStep(2);
      adviceButton.disabled = true;
      showStep(1);
      refreshSelection();
    };
    const goToInterests = () => {
      clearStep(2);
      adviceButton.disabled = true;
      showStep(2);
      refreshSelection();
    };

    adviceButton.addEventListener('click', () => {
      if (adviceButton.disabled || !choices[2].length) return;
      renderResults(true);
    });

    root.addEventListener('click', (event) => {
      const choice = event.target.closest('.mbf-choice[data-step]');
      const again = event.target.closest('#again');
      const top = event.target.closest('#top, .mbf-restart');
      if (!choice && !again && !top) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (choice) {
        const step = Number(choice.dataset.step);
        if (step === 2) {
          const selected = new Set(choices[2]);
          if (choice.dataset.value === 'maakt-niet-uit') {
            selected.clear(); selected.add(choice.dataset.value);
          } else {
            selected.delete('maakt-niet-uit');
            if (selected.has(choice.dataset.value)) selected.delete(choice.dataset.value);
            else selected.add(choice.dataset.value);
          }
          choices[2] = [...selected];
          steps[2].querySelectorAll('.mbf-choice').forEach((button) => button.classList.toggle('is-active', selected.has(button.dataset.value)));
          adviceButton.disabled = choices[2].length === 0;
          refreshSelection();
        } else if (step === 3) {
          choices[3] = choice.dataset.value === 'kind' ? 'kind' : 'volwassene';
          steps[3].querySelectorAll('.mbf-choice:not([data-value="erotisch"])').forEach((button) => button.classList.toggle('is-active', button === choice));
          goToOccasion();
        } else {
          choices[1] = `${choice.dataset.value || ''} ${choice.textContent || ''}`;
          steps[1].querySelectorAll('.mbf-choice').forEach((button) => button.classList.toggle('is-active', button === choice));
          goToInterests();
        }
      } else if (again) previousSelection();
      else if (top) startOver();
    }, true);

    root.dataset.mbGiftReady = 'true';
    startOver(false);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
